import React from 'react'
import PropTypes from 'prop-types'
import {List, ListItem} from '@chakra-ui/react'

const AddressDisplay = ({address, as: Component = List}) => {
    const apartment = address.c_apartment || address.apartment || address.address2

    return (
        <Component>
            <ListItem>{[address.address1, apartment].filter(Boolean).join(', ')}</ListItem>
            <ListItem>
                {[address.city, address.stateCode, address.postalCode].filter(Boolean).join(', ')}
            </ListItem>
        </Component>
    )
}

AddressDisplay.propTypes = {
    address: PropTypes.object.isRequired,
    as: PropTypes.elementType
}

export default AddressDisplay
